// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import Text from "../../Text";

// constants
import theming from "../../../constants/theming";

const { useTheme } = theming;

function EstimateResume(props) {
  const { resume } = props;

  const intl = useIntl();
  const theme = useTheme();

  return (
    <Text style={{ color: theme.PRIMARY_COLOR_DARKEN }}>
      {intl.formatMessage(
        {
          defaultMessage:
            "Réservation du {checkin} à partir de {arrival} jusqu’au {checkout} à {departure} pour {adults, plural, one {un adulte} other {# adultes}}{childs, plural, =0 {} one {, un enfant} other {, # enfants}}{babies, plural, =0 {} one {, un bébé} other {, # bébés}}.{pets, plural, =0 {} one {\nUn animal sera présent} other {\n# animaux seront présents.}}",
        },
        {
          checkin: intl.formatDate(resume.checkin, {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            weekday: "long",
          }),
          checkout: intl.formatDate(resume.checkout, {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            weekday: "long",
          }),
          departure: intl.formatTime(resume.departure, {
            hour: "numeric",
            minute: "numeric",
          }),
          arrival: intl.formatTime(resume.arrival, {
            hour: "numeric",
            minute: "numeric",
          }),
          adults: resume.adults,
          childs: resume.childs,
          babies: resume.babies,
          pets: resume.pets,
        }
      )}
    </Text>
  );
}

export default EstimateResume;
